/* MMG v3.12.5 · canonical navigation loader.
 * One responsibility: load canonical navigation base, then storefront unification.
 * Kairos fresh-session runtime is footer-owned. Browser API prototypes are never patched.
 */
(function(){
  'use strict';
  if(window.__MMG_CANONICAL_NAV_LOADER_V3125__)return;
  window.__MMG_CANONICAL_NAV_LOADER_V3125__=true;

  var current=document.currentScript;
  var src=current&&current.src;
  if(!src)return;

  function assetScript(filename,datasetName){
    if(document.querySelector('script['+datasetName+']'))return null;
    var url=new URL(src,location.href);
    url.pathname=url.pathname.replace(/mmg-canonical-navigation\.js$/,filename);
    var script=document.createElement('script');
    script.src=url.toString();
    script.async=false;
    script.setAttribute(datasetName,'true');
    return script;
  }

  function loadUnificationRuntime(){
    var runtime=assetScript('mmg-site-unification-v396.js','data-mmg-site-unification-v396');
    if(runtime)document.head.appendChild(runtime);
  }

  var base=assetScript('mmg-canonical-navigation-v395-base.js','data-mmg-canonical-navigation-v395-base');
  if(!base){
    loadUnificationRuntime();
    return;
  }
  base.onload=base.onerror=loadUnificationRuntime;
  document.head.appendChild(base);
})();
